import {useState, useEffect, useMemo} from 'react'
import {useNavigate} from 'react-router-dom'

import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import VisibilityIcon from '@mui/icons-material/Visibility'
import PeopleIcon from '@mui/icons-material/People'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import Table from '../../shared/Table'

import {connect} from '../../../state/hooks/tools'
import {formatDate} from '../../../lib/data'
import {readEndpoint} from '../../../lib/asyncMethods'
import {USERS} from '../../../state/actionTypes'

import './users.scss'

const COLUMNS = [
  {
    width: 130,
    headerName: 'First Name',
    field: 'firstName'
  },
  {
    width: 130,
    headerName: 'Last Name',
    field: 'lastName'
  },
  {
    width: 130,
    headerName: 'Blocked LogIn',
    field: 'blockLogin',
    renderCell: params => (
      <span>{params.value ? 'Yes' : 'No'}</span>
    )
  },
  {
    width: 130,
    headerName: 'LogIn Count',
    field: 'loginCount'
  },
  {
    width: 150,
    headerName: 'Last Login At',
    field: 'lastLoginAt',
    renderCell: params => (
      <span>{params.value && formatDate(params.value)}</span>
    )
  },
  {
    width: 130,
    headerName: 'Created At',
    field: 'createdAt',
    renderCell: params => (
      <span>{formatDate(params.value)}</span>
    )
  }
]

const Users = props => {
  const navigate = useNavigate()
  const [records, setRecords] = useState(props.users || [])
  const [rowCount, setRowCount] = useState(props.usersMeta?.count || 0)
  const [paginationModel, setPaginationModel] = useState({page: 0, pageSize: 12})

  useEffect(() => {
    const {page, pageSize} = paginationModel
    const currentPage = page + 1

    props.readEndpoint(`users?page=${currentPage}&size=${pageSize}`).then(response => {
      if (response.success) {
        setRecords(response.data)
        setRowCount(response.meta.count)
      }
    })
  }, [paginationModel])

  const handleRowClick = row => {
    navigate(row.id)
  }

  const actions = useMemo(() => ({
    width: 100,
    field: 'actions',
    headerName: 'Actions',
    type: 'actions',
    getActions: params => ([
      <IconButton onClick={() => handleRowClick(params)} color='primary'>
        <VisibilityIcon />
      </IconButton>
    ])
  }), [])

  return (
    <Stack className='users'>
      <Stack className='label' direction='row'>
        <PeopleIcon fontSize='large' />
        <Typography variant='h5'>Users</Typography>
      </Stack>
      <Divider />
      <Table
        records={records}
        columns={[...COLUMNS, actions]}
        height={700}
        handleRowClick={handleRowClick}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        rowCount={rowCount}
        isLoading={props.loading}
      />
    </Stack>
  )
}

const mapStateToProps = ({users}) => ({...users})

const actionCreators = ({users}) => ({readEndpoint: readEndpoint(users, USERS)})

export default connect(mapStateToProps, actionCreators)(Users)
